<template>
    <div class="sa-problem-list">
        <strong class="sa-d-block sa-darkblue-text sa-mb20">Member history / Problem list</strong>
        <ul class="sa-card-list-gray sa-card sa-card-noshadow">
            <li v-for="(n,i) of problems" :key="i">
                <div class="sa-card-list-box">
                    <div class="sa-doct-det sa-app-text">{{n.problem}}</div>
                    <div class="sa-doct-det sa-app-text sa-text-right" :ref="presDiag1" @click="openToggle(i)" :class="open1[i]?'active':''">
                        <span  :class="{ 'icon-plus sa-added-med': !open1[i], 'icon-minus sa-added-med': open1[i] }"></span>
                    </div>
                </div>
                <div v-show="open1[i]">
                    <hr />
                    <div class="sa-row">
                        <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <div class="sa-form-group">
                                <label>Problem</label>
                                <span>{{n.problem}}</span>
                            </div>
                        </div>
                        <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <div class="sa-form-group">
                                <label>Onset</label>
                                <span>{{n.onset}}</span>
                            </div>
                        </div>
                        <div class="sa-col-xs12 sa-col-sm4 sa-col-md4 sa-col-lg4">
                            <div class="sa-form-group">
                                <label>Problem Note</label>
                                <span>{{n.problem_note}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    props:["problems"],
    data(){
        return{
            i : null,
            open1: {},
            presDiag1: 0,
            presDiag: 0,
            open: {},
        }
    },
    methods:{
        openToggle(i) {
            let _self = this
            let flag = !_self.open1[i]
            _self.$set(_self.open1, i, flag)
            _self.presDiag1 += 1
        }
    }
}
</script>